import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';

export const GET_ALL_CONTROLLING_PERSONS_REQUEST = 'GET_ALL_CONTROLLING_PERSONS_REQUEST';
export const GET_ALL_CONTROLLING_PERSONS_SUCCESS = 'GET_ALL_CONTROLLING_PERSONS_SUCCESS';
export const GET_ALL_CONTROLLING_PERSONS_FAILURE = 'GET_ALL_CONTROLLING_PERSONS_FAILURE';

function getAllControllingPersonsRequest() {
  return {
    type: GET_ALL_CONTROLLING_PERSONS_REQUEST
  };
}

function getAllControllingPersonsRecieved(controllingPersons) {
  return {
    type: GET_ALL_CONTROLLING_PERSONS_SUCCESS,
    controllingPersons
  };
}

function getAllControllingPersonsFailed() {
  return {
    type: GET_ALL_CONTROLLING_PERSONS_FAILURE,
  };
}

export function getAllControllingPersons(accountId) {
  return (dispatch) => {
    dispatch(getAllControllingPersonsRequest());
    const promise = () => ApiService
      .getAllControllingPersons(accountId)
      .then(response => dispatch(getAllControllingPersonsRecieved(response.data)))
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, getAllControllingPersonsFailed, true));
        }
      });
    return promise();
  };
}
